// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

import { CssBaseline } from "@mui/material";
import { Provider } from "react-redux";
import store from "./redux/store";
import { BrowserRouter as Router } from "react-router-dom";
import { AuthContextProvider } from "./context";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
    <React.StrictMode>
        <Router>
            <AuthContextProvider>
                <Provider store={store}>
                    <CssBaseline />
                    <App />
                </Provider>
            </AuthContextProvider>
        </Router>
    </React.StrictMode>
);
